/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TextFile } from './TextFile';
import {
    TextFileFromJSON,
    TextFileFromJSONTyped,
    TextFileToJSON,
} from './TextFile';

/**
 * 
 * @export
 * @interface OpenFileRequest
 */
export interface OpenFileRequest {
    /**
     * 
     * @type {TextFile}
     * @memberof OpenFileRequest
     */
    fileContent: TextFile;
}

/**
 * Check if a given object implements the OpenFileRequest interface.
 */
export function instanceOfOpenFileRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileContent" in value;

    return isInstance;
}

export function OpenFileRequestFromJSON(json: any): OpenFileRequest {
    return OpenFileRequestFromJSONTyped(json, false);
}

export function OpenFileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenFileRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileContent': TextFileFromJSON(json['fileContent']),
    };
}

export function OpenFileRequestToJSON(value?: OpenFileRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileContent': TextFileToJSON(value.fileContent),
    };
}

